import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Action, Panel, PanelHead } from '../aa';
import type { BillingCard } from '../../services/billingApi';
import { cardName, startOwnCardSetup } from './UsageWalletPanel';

/* Each Owner pays with their own card. The card shown is the viewer's, and
 * no other Owner can charge it. */
export const OwnCardPanel: React.FC<{
  card: BillingCard | null;
  planPayerEmail?: string | null;
  viewerEmail?: string;
  onTeamPlan: boolean;
}> = ({ card, planPayerEmail = null, viewerEmail = '', onTeamPlan }) => {
  const [busy, setBusy] = useState(false);

  const openCardPage = async () => {
    setBusy(true);
    try {
      await startOwnCardSetup();
    } catch {
      toast.error('Could not open the card page. Try again.');
      setBusy(false);
    }
  };

  let title = 'No card yet';
  let desc = 'Each Owner pays with their own card. Add yours to add seats, renew or add funds. No other Owner can use it.';
  let label = 'Add your card';
  if (card) {
    title = cardName(card);
    desc = 'Seats, renewals and funds you buy are charged to this card only. No other Owner can use it.';
    label = 'Replace card';
  }

  let payerLine = '';
  if (onTeamPlan && planPayerEmail && planPayerEmail === viewerEmail) {
    payerLine = 'Team plan renewals and seats added when people join are charged to your card, because you started the plan.';
  }
  if (onTeamPlan && planPayerEmail && planPayerEmail !== viewerEmail) {
    payerLine = `Team plan renewals and seats added when people join are charged to ${planPayerEmail}'s card, who started the plan.`;
  }

  return (
    <Panel>
      <PanelHead
        kicker="Your card"
        title={title}
        desc={desc}
        action={(
          <Action variant="outline" onClick={openCardPage} disabled={busy} reason="Working">
            {label}
          </Action>
        )}
      />
      {payerLine && <div className="px-6 pb-5 text-[12.5px] text-ink-dim">{payerLine}</div>}
    </Panel>
  );
};
